/**
 * Cart integrity for Pumper qty-packs + free gift.
 * - Merge same-variant serum lines (pack 2 then pack 3 → one line).
 * - Drop extra Pumper gift lines (Function only 100% offs one).
 * - Drop orphan Pumper gifts when serum is gone.
 * - Re-paint drawer + icon from section HTML so Ajax add never leaves
 *   an empty drawer with a badge (add.js sections can miss cart-drawer).
 * Does not remove a Dermstamp the customer added themselves (no pmpr_gift_product).
 */
(function () {
  if (window.__aevinHygieneBoot) return;
  window.__aevinHygieneBoot = true;

  var cfg = window.__aevinCartCfg || {};
  var serumHandle = cfg.serum || 'aevin-hair-growth-scalp-serum';
  var giftHandle = cfg.gift || 'aevin-adjustable-dermstamp';
  var serumVariant = cfg.serumVariant != null ? String(cfg.serumVariant) : '';
  var busy = false;
  var queued = false;

  function isPumperGift(item) {
    var p = item.properties || {};
    return p.pmpr_gift_product != null;
  }
  function linePrice(item) {
    if (typeof item.final_line_price === 'number') return item.final_line_price;
    if (typeof item.line_price === 'number') return item.line_price;
    return 0;
  }
  function handleOf(item) {
    return item.handle || item.product_handle || '';
  }
  function isSerum(item) {
    if (isPumperGift(item)) return false;
    if (handleOf(item) === serumHandle) return true;
    if (serumVariant && String(item.variant_id) === serumVariant) return true;
    return false;
  }
  function visibleCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (item) {
      if (isPumperGift(item) && linePrice(item) === 0) return;
      n += item.quantity;
    });
    return n;
  }
  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      var ct = (r.headers.get('content-type') || '').toLowerCase();
      if (!r.ok || ct.indexOf('json') === -1) throw new Error(String(r.status));
      return r.json();
    });
  }
  function fetchCart() {
    return jsonFetch('/cart.js').catch(function () {
      return jsonFetch('/cart.json');
    });
  }

  function refreshIcon() {
    var dest = document.querySelector('#cart-icon-bubble');
    if (!dest) return Promise.resolve();
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(base + '?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var src = html.querySelector('#cart-icon-bubble') || html.querySelector('.shopify-section');
        if (src && dest) dest.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  function paintDrawer(cart) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', visibleCount(cart) === 0);
    var dest = document.querySelector('#CartDrawer');
    if (!dest) return refreshIcon();
    return fetch('/cart?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var src = html.querySelector('#CartDrawer');
        if (src && dest) dest.innerHTML = src.innerHTML;
        var overlay = document.querySelector('#CartDrawer-Overlay');
        if (overlay && drawer) {
          overlay.addEventListener('click', function () { drawer.close(); });
        }
      })
      .catch(function () {})
      .then(refreshIcon);
  }

  window.__aevinPaintCart = function () {
    return fetchCart().then(paintDrawer).catch(function () {});
  };

  function run() {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;
    fetchCart()
      .then(function (cart) {
        var updates = {};
        var changed = false;
        var serumIn = false;
        var serumLines = {};
        var pumperGifts = [];

        (cart.items || []).forEach(function (item) {
          if (isSerum(item)) {
            serumIn = true;
            var vid = String(item.variant_id);
            if (!serumLines[vid]) serumLines[vid] = [];
            serumLines[vid].push(item);
          }
          if (handleOf(item) === giftHandle && isPumperGift(item)) pumperGifts.push(item);
        });

        Object.keys(serumLines).forEach(function (vid) {
          var lines = serumLines[vid];
          if (lines.length < 2) return;
          var total = 0;
          lines.forEach(function (l) { total += l.quantity; });
          updates[lines[0].key] = total;
          for (var i = 1; i < lines.length; i++) updates[lines[i].key] = 0;
          changed = true;
        });

        if (!serumIn) {
          pumperGifts.forEach(function (g) {
            updates[g.key] = 0;
            changed = true;
          });
        } else if (pumperGifts.length) {
          var freeG = pumperGifts.filter(function (g) { return linePrice(g) === 0; });
          var paidG = pumperGifts.filter(function (g) { return linePrice(g) > 0; });
          if (freeG.length) {
            paidG.forEach(function (g) {
              updates[g.key] = 0;
              changed = true;
            });
            freeG.slice(1).forEach(function (g) {
              updates[g.key] = 0;
              changed = true;
            });
          } else if (paidG.length > 1) {
            paidG.slice(1).forEach(function (g) {
              updates[g.key] = 0;
              changed = true;
            });
          }
        }

        if (!changed) return paintDrawer(cart);
        return jsonFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function (next) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aevin-hygiene', cartData: next });
          }
          return paintDrawer(next);
        });
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
        if (queued) {
          queued = false;
          run();
        }
      });
  }

  function schedule() {
    [150, 700, 1800].forEach(function (ms) {
      setTimeout(run, ms);
    });
  }

  function lockLinePrices() {
    document.querySelectorAll('[data-aevin-line-pay]').forEach(function (el) {
      var want = el.getAttribute('data-aevin-line-pay');
      if (want && el.textContent.trim() !== want) el.textContent = want;
    });
  }
  if (!window.__aevinPriceLock) {
    window.__aevinPriceLock = true;
    try {
      new MutationObserver(lockLinePrices).observe(document.documentElement, {
        subtree: true,
        childList: true,
        characterData: true,
      });
    } catch (e) {}
    setInterval(lockLinePrices, 400);
  }

  function boot() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'aevin-hygiene') return;
        schedule();
      });
    }
    var orig = window.fetch;
    if (!orig.__aevinHygieneWrapped) {
      var wrapped = function () {
        var args = arguments;
        return orig.apply(this, args).then(function (res) {
          try {
            var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
            if (/\/cart\/(add|change|update|clear)/.test(url) && url.indexOf('aevin-hygiene') === -1) {
              schedule();
            }
          } catch (e) {}
          return res;
        });
      };
      wrapped.__aevinHygieneWrapped = true;
      window.fetch = wrapped;
    }
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
